<template>
  <div
    class="l-replay-container"
    :class="{ 'not-allowed': repeatNumber == 0 || notAllowed }"
    @click="onPlay"
  >
    <div class="l-replay-main">
      <img class="l-image-replay" src="./images/replay.png" />
      <img class="l-image-x" src="./images/x.png" alt="" />
      <span class="l-image-num">{{ repeatNumber }}</span>
    </div>
    <img v-if="play" class="l-image-voice" src="./images/voiceAnimation.gif" />
    <img v-if="!play" class="l-image-voice" src="./images/voice.png" />
  </div>
</template>

<script>
export default {
  name: 'l-replay',
  props: {
    play: {
      type: Boolean,
    },
    repeatNumber: {
      type: Number,
    },
    notAllowed: {
      type: Boolean,
    },
  },
  methods: {
    onPlay() {
      if (!this.play && this.repeatNumber > 0 && !this.notAllowed) {
        this.$emit('replay')
      }
    },
  },
}
</script>

<style lang="stylus">
@import './index.styl'
</style>
